import React from 'react'

const Car = () => {
  return (
    <div>Car</div>
  )
}

export default Car